
(function () {
    "use strict";


    // @ngInject
    function WorkspaceFileServiceCtor($state, $q, $translate,
                                      AppStates, PreviewModeService, UIUtils, Enums, DeviceService,
                                      AnalyticsService, PopupMessageService, ModalService, OnboardingService, AbTestService,
                                      WorkspaceFilesManager, UsersManager, moment, PvlService, $window, EmailPreviewManager,
                                      _, EventsManager, UiPersistenceService, PendingTasksManager, FeaturesService, QuestionsStateService, FacebookPixelTrackingService) {

        this.$state = $state;
        this.$q = $q;
        this.$translate = $translate;
        this.AppStates = AppStates;
        this.AnalyticsService = AnalyticsService;
        this.PopupMessageService = PopupMessageService;
        this.UIUtils = UIUtils;
        this.Enums = Enums;
        this.WorkspaceFilesManager = WorkspaceFilesManager;
        this.ModalService = ModalService;
        this.UsersManager = UsersManager;
        this.OnboardingService = OnboardingService;
        this.AbTestService = AbTestService;
        this.moment = moment;
        this.PvlService = PvlService;
        this.$window = $window;
        this.EmailPreviewManager = EmailPreviewManager;
        this.DeviceService = DeviceService;
        this.PreviewModeService = PreviewModeService;
        this.UiPersistenceService = UiPersistenceService;
        this._ = _;
        this.EventsManager = EventsManager;
        this.PendingTasksManager = PendingTasksManager;
        this.FeaturesService = FeaturesService;
        this.QuestionsStateService = QuestionsStateService;
        this.FacebookPixelTrackingService = FacebookPixelTrackingService;
        this._backToState = null;
    }

    function isBookedVersion(file, versionObj) {
        if (versionObj) {
            return versionObj.is_booked;
        } else {
            return file.isBookedVersion();
        }
    }

    function isActiveVersion(file, versionObj) {
        if (versionObj) {
            return versionObj.is_active;
        } else {
            return file.isActiveVersion();
        }
    }

    Services.WorkspaceFileService = Class(function () {
        var registry = {};


        return {

            constructor: WorkspaceFileServiceCtor,

            fileStatuses: {
                new_workspace_create: 0,
                welcome_email_sent: 1,
                welcome_brochure_seen: 2,
                questionnaire_seen: 3,
                questionnaire_answered: 4,
                proposal_created: 5,
                proposal_sent: 6,
                proposal_brochure_seen: 7,
                proposal_seen: 8,
                agreement_seen: 9,
                agreement_signed: 10,
                payments_seen: 11,
                retainer_paid: 12,
                payment_done: 13

            },

            //WORKSPACE_FILE_TYPE = [:proposal, :invoice, :direct_payment, :questionnaire, :brochure, :timeline, :agreement]
            fileTypes: {
                proposal : 0,
                invoice : 1,
                direct_payment : 2,
                questionnaire : 3,
                brochure: 4,
                timeline: 5,
                agreement: 6
            },

            WorkspaceStatus: {
                lead: 0,
                lead_archived: 1,
                client: 2,
                client_archived: 3,
                lead_sent: 4
            },

            getStatusClasses: function getStatusClasses(workspaceFile) {
                return this.getStatusClassesArray(workspaceFile).join(' ');
            },

            getStatusClassesArray: function getStatusClasses(workspaceFile) {
                return [
                    this.UIUtils.generateClassByFileType(workspaceFile.file_type_cd),
                    this.UIUtils.generateClassForFileType(workspaceFile),
                    workspaceFile.status,
                    workspaceFile.status_type,
                    workspaceFile.workspace_status_type,
                    this.UIUtils.generateClassForActiveState(workspaceFile.active_state),
                    this.UIUtils.generateClassForRequest(workspaceFile.request_active),
                    this.UIUtils.generateClassForCanceledState(workspaceFile.is_canceled),
                    this.UIUtils.generateClassForEditableState(workspaceFile.isEditable()),
                    this.UIUtils.generateClassForDraftMode(workspaceFile.isDraft())
                ];
            },

            getSendFileLabel: function getSendFileLabel(workspaceFile, workspace) {
                if (workspaceFile.isDirectPayment()){
                    return 'FILE.SEND_FILE.DIRECT_PAYMENT._PAY_TO_';
                }

                var hasValidRecipient = workspace ? workspace.hasValidRecipient() : workspaceFile.hasValidRecipient();

                if(!hasValidRecipient && workspaceFile.isOwnerMode()) {
                    return 'FILE.SEND_FILE.GENERAL_FILE._NEXT_ADD_CLIENT_';
                }

                var statusToTranslate;
                if (workspaceFile.isSent()) {
                    statusToTranslate = 'FILE.SEND_FILE' + this.getFileTypeTranslationPrefix(workspaceFile.file_type_cd) + '._RESEND_';
                } else {
                    statusToTranslate = 'FILE.SEND_FILE.GENERAL_FILE._NEXT_';
                }

                return statusToTranslate;
            },

            getFileTypeTranslationPrefix: function getFileTypeTranslationPrefix(fileType) {
                var statusToTranslate;

                if (fileType === this.fileTypes.proposal) {
                    statusToTranslate = '.PROPOSAL';
                } else if(fileType === this.fileTypes.invoice){
                    statusToTranslate = '.INVOICE';
                } else if(fileType === this.fileTypes.questionnaire){
                    statusToTranslate = '.QUESTIONNAIRE';
                } else if(fileType === this.fileTypes.brochure){
                    statusToTranslate = '.BROCHURE';
                } else if(fileType === this.fileTypes.timeline){
                    statusToTranslate = '.TIMELINE';
                } else if (fileType === this.fileTypes.agreement) {
                    statusToTranslate = '.AGREEMENT';
                } else {
                    statusToTranslate = '.PROPOSAL';
                }

                return statusToTranslate;
            },

            getStatusLabelForVendor: function getStatusLabelForVendor(fileType, fileStatus) {
                var statusToTranslate = 'FILE.FILE_STATUS';

                statusToTranslate = statusToTranslate + '.VENDOR';

                statusToTranslate = statusToTranslate + this.getFileTypeTranslationPrefix(fileType);

                statusToTranslate = statusToTranslate + '.' + this.Enums.WorkspaceFileStatus[fileStatus];

                return statusToTranslate;
            },

            getStatusLabel: function getStatusLabel(workspaceFile, forceVendor) {
                var statusToTranslate = 'FILE.FILE_STATUS';

                if (forceVendor || workspaceFile.isModeratorMode()) {
                    statusToTranslate += '.VENDOR';
                } else {
                    statusToTranslate += '.CLIENT';
                }

                statusToTranslate += this.getFileTypeTranslationPrefix(workspaceFile.file_type_cd);

                if (workspaceFile.hasPendingPayment()) {
                    statusToTranslate += '.' + '_PAYMENT_PENDING_';
                }
                else {
                    statusToTranslate += '.' + this.Enums.WorkspaceFileStatus[workspaceFile.status_cd];
                }

                return statusToTranslate;

            },

            getFileType: function getFileType(fileTypeEnum){
                for(var fileType in this.fileTypes) {
                    if (fileTypeEnum === this.fileTypes[fileType]){
                        return [fileType][0].replace(/_/g, ' ');
                    }
                }
            },

            getFileCardClasses: function getFileCardClasses(workspaceFile) {
                var cardClasses = this.getStatusClassesArray(workspaceFile);
                return cardClasses.join(' ');
            },

            getProposalLabel: function getProposalLabel(workspaceFile) {
                if (workspaceFile.isProposal()){
                    return 'FILE.RIBBON_LABEL._PROPOSAL_';
                }

                if (workspaceFile.isInvoice()){
                    return 'FILE.RIBBON_LABEL._INVOICE_';
                }

                if (workspaceFile.isQuestionnaire()){
                    return 'FILE.RIBBON_LABEL._QUESTIONS_';
                }

                if (workspaceFile.isBrochure()){
                    return 'FILE.RIBBON_LABEL._BROCHURE_';
                }

                if (workspaceFile.isTimeline()){
                    return 'FILE.RIBBON_LABEL._TIMELINE_';
                }

                if (workspaceFile.isAgreement()){
                    return 'FILE.RIBBON_LABEL._AGREEMENT_';
                }

                return 'FILE.RIBBON_LABEL._PROPOSAL_';
            },

            gotoPayView: function gotoPayView(workspaceFileId, extraParams, options) {
                extraParams = extraParams || {};
                this.$state.go(this.AppStates.root_core_workspaceFile_stepPayment, angular.extend(extraParams, {workspace_file_id: workspaceFileId}), options);
            },

            gotoWorkspaceFileById: function gotoWorkspaceFileById(workspaceFileId, isPreviewMode, params, isReplaceUrl){
                var self = this;
                params = params || {};
                return this.WorkspaceFilesManager.getWorkspaceFileStatusData(workspaceFileId).then(
                    function statusSuccess(resp){
                        if (isPreviewMode) {
                            params.shouldExplicitlyExitPreviewtoEditFile = true;
                            params.isSendFilePreview = isPreviewMode === 'send_file_preview';
                            self.PreviewModeService.enter(resp.model, params);
                        } else {
                            var versionObj = null;
                            if(params.version){
                                versionObj = resp.model.file_version_container.versions.find(function (version) {
                                    return version.file_version === params.version;
                                });
                            }
                            self.gotoWorkspaceFileView(resp.model, versionObj, isReplaceUrl, params.reload);
                        }

                    },
                    function error(resp) {
                        if (resp) {
                            self.PopupMessageService.showAlert(self.PopupMessageService.severityTypes.warning,
                                {
                                    translationId: 'FILE.ALERTS._UNABLE_TO_FIND_THE_FILE_',
                                    interpolateParams: {
                                        userName: self.UsersManager.getCurrUser().first_name
                                    }
                                },
                                function successCallback() {
                                    this.$state.go(this.AppStates.root_core_navigation_dashboard);
                                }.bind(this),
                                'FILE.ALERTS._PRINT_ERROR_POPUP_BTN_'
                            );
                        }
                    }.bind(this));
            },

            gotoWorkspaceFileSummary: function gotoWorkspaceFileSummary(workspaceFileId, fileVersion, options){
                this.$state.go(this.AppStates.root_core_workspaceFile, {workspace_file_id: workspaceFileId, file_version: fileVersion, force:true}, options);
            },

            gotoWorkspaceFileView: function gotoWorkspaceFileView(workspaceFile, versionObj, replace, reload) {
                var versionNumber = versionObj ? versionObj.file_version : null;
                var workspaceFileId = workspaceFile._id;
                var options = {};
                if (replace){
                    options.location = "replace";
                }

                if(reload) {
                    options.reload = true;
                }

                // brochure - always show the controller and not the summary
                if (workspaceFile.isBrochure()){
                    this.$state.go(this.AppStates.root_core_workspaceFile_brochure, {workspace_file_id: workspaceFileId}, options);
                    return;
                }

                // timeline - always show the controller and not the summary
                if (workspaceFile.isTimeline()){
                    this.$state.go(this.AppStates.root_core_workspaceFile_timeline, {workspace_file_id: workspaceFileId}, options);
                    return;
                }

                if (workspaceFile.isOwnerMode() || workspaceFile.isViewOnlyMode()) {
                    this.gotoWorkspaceFileSummary(workspaceFileId, versionNumber, options);
                    return;
                }

                // CLIENT!
                if (workspaceFile.isCanceled() || workspaceFile.hasPendingPayment()) {
                    //go to general file view (summary). ignore state
                    this.gotoWorkspaceFileSummary(workspaceFileId, versionNumber, options);
                    return;
                }

                var status_cd_to_follow = workspaceFile.status_cd;
                if(workspaceFile.hasPayments() && !workspaceFile.isBooked()) {
                    status_cd_to_follow = workspaceFile.file_version_container.active_content.status_cd;
                }

                if (workspaceFile.isQuestionnaire()){
                    this.$state.go(this.AppStates.root_core_workspaceFile_stepQuestionnaire, {workspace_file_id: workspaceFileId}, options);
                    return;
                }

                switch (status_cd_to_follow) {
                    case this.fileStatuses.proposal_sent:
                    case this.fileStatuses.proposal_seen:
                        if (workspaceFile.isQuestionnaire()) {
                            this.$state.go(this.AppStates.root_core_workspaceFile_stepQuestionnaire, {workspace_file_id: workspaceFileId}, options);
                        } else if (workspaceFile.isAgreement()) {
                            this.$state.go(this.AppStates.root_core_workspaceFile_stepAgreement, {workspace_file_id: workspaceFileId}, options);
                        } else if (isActiveVersion(workspaceFile, versionObj) && (!isBookedVersion(workspaceFile, versionObj) || workspaceFile.is_booked_manually)) {
                            this.$state.go(this.AppStates.root_core_workspaceFile_stepProposal, {workspace_file_id: workspaceFileId}, options);
                        } else {
                            this.gotoWorkspaceFileSummary(workspaceFileId, versionNumber, options);
                        }

                        break;

                    case this.fileStatuses.agreement_seen:
                        if(!workspaceFile.isQuestionnaire() && isActiveVersion(workspaceFile, versionObj) && (!isBookedVersion(workspaceFile, versionObj) || workspaceFile.is_booked_manually)) {
                            this.$state.go(this.AppStates.root_core_workspaceFile_stepAgreement, {workspace_file_id: workspaceFileId}, options);
                        } else {
                            this.gotoWorkspaceFileSummary(workspaceFileId, versionNumber, options);
                        }
                        break;

                    case this.fileStatuses.agreement_signed:
                        if(!workspaceFile.isAgreement() && workspaceFile.isProposal() && isActiveVersion(workspaceFile, versionObj) && isBookedVersion(workspaceFile, versionObj)) {
                            this.$state.go(this.AppStates.root_core_workspaceFile_stepAgreement, {workspace_file_id: workspaceFileId}, options);
                        } else {
                            this.gotoWorkspaceFileSummary(workspaceFileId, versionNumber, options);
                        }
                        break;

                    case this.fileStatuses.payments_seen:
                        if ((workspaceFile.isProposal() && isActiveVersion(workspaceFile, versionObj) && isBookedVersion(workspaceFile, versionObj)) || (workspaceFile.isInvoice() && isActiveVersion(workspaceFile, versionObj))) {
                            this.$state.go(this.AppStates.root_core_workspaceFile_stepPayment, {workspace_file_id: workspaceFileId}, options);
                        } else {
                            this.gotoWorkspaceFileSummary(workspaceFileId, versionNumber, options);
                        }
                        break;

                    case this.fileStatuses.retainer_paid:
                    case this.fileStatuses.payment_done:
                        this.gotoWorkspaceFileSummary(workspaceFileId, versionNumber, options);
                        break;
                    default:
                        window.console.log("state " + workspaceFile.status + " is not supported");
                        this.$state.go(this.AppStates.root_core_workspaceFile_stepProposal, {workspace_file_id: workspaceFileId}, options);
                }
            },

            printWorkspaceFile: function printWorkspaceFile(workspaceFile) {
                if (this.DeviceService.isInAppBrowser()) {
                    window.ReactNativeWebView && window.ReactNativeWebView.postMessage('hb_app_print', "*");
                } else {
                    var analyticsArgs = {workspace_file: workspaceFile._id};
                    var self = this;
                    workspaceFile.print("all").then(
                        function success() {
                            self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.file_print_successful, analyticsArgs);
                        },
                        function error() {
                            self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.file_print_error, analyticsArgs);

                            self.PopupMessageService.showAlert(self.PopupMessageService.severityTypes.warning,
                                'FILE.ALERTS._PRINT_ERROR_POPUP_', null, 'FILE.ALERTS._PRINT_ERROR_POPUP_BTN_');
                        }
                    );
                }
            },

            whichCurrentFileView: function whichCurrentFileView(workspaceFile) {
                if (!workspaceFile) {
                    return;
                }
                var currentFileView;
                var fileViews = {
                    owner: 'owner',
                    client: 'client',
                    clientPreview: 'preview',
                    sendTestFilePreview: 'test'
                };

                if (workspaceFile.isOwnerMode()) {
                    currentFileView = fileViews.owner;
                }
                if (workspaceFile.isClientMode()) {
                    currentFileView = fileViews.client;
                }

                if (this.PreviewModeService.inPreviewMode) {
                    this.PreviewModeService.inSendFilePreviewMode
                        ? currentFileView = fileViews.sendTestFilePreview
                        : currentFileView = fileViews.clientPreview;
                }

                return currentFileView;
            },

            downloadAsPdfFile: function downloadAsPdfFile(workspaceFile, body) {
                // var analyticsArgs = {workspace_file: workspaceFile._id};
                if (this.DeviceService.isInAppBrowser()) {
                    window.ReactNativeWebView && window.ReactNativeWebView.postMessage('hb_app_print_pdf', "*");
                } else {
                    this.$window.print();
                }
            },

            generateAnalyticsProps: function generateAnalyticsProps(workspaceFile) {
                if (workspaceFile) {

                    var ownerName, ownerEmail, ownerId, ownerUserType, ownerHBUserType, ownerCompanyId, ownerCompanyRole, ownerCompanyName, ownerCompanyType,isNotOwnerOpen,isOwnerOpen;
                    if (workspaceFile.owner) {
                        var owner = workspaceFile.owner;
                        ownerName = owner.full_name;
                        ownerEmail = owner.email;
                        ownerId = owner._id;
                        ownerUserType = owner.system_user_type;
                        ownerCompanyRole = owner.company_role;
                        ownerHBUserType = Array.isArray(owner.hb_user_type) ? owner.hb_user_type[0] : '';
                        var currUser = this.UsersManager.getCurrUser();
                        if (currUser.isVendor() && workspaceFile.owner.isMyTeamMember()) {
                            isNotOwnerOpen = currUser._id !== owner._id;
                        }
                        isOwnerOpen = currUser._id === owner._id;

                        if (owner.company) {
                            var company = owner.company;
                            ownerCompanyId = company._id;
                            ownerCompanyName = company.company_name;
                            ownerCompanyType = company.company_type_name;
                        }
                    }
                    return {file_id: workspaceFile._id,
                        file_title: workspaceFile.file_title,
                        file_type: workspaceFile.file_type,
                        file_status: workspaceFile.status_name,
                        file_workspace_name: workspaceFile.workspace_name,
                        file_event_name: workspaceFile.event ? workspaceFile.event.event_name : '',
                        file_owner_id: ownerId,
                        file_owner_name: ownerName,
                        file_owner_email: ownerEmail,
                        file_owner_user_type: ownerUserType,
                        file_owner_hb_user_type: ownerHBUserType,
                        file_owner_company_id: ownerCompanyId,
                        file_owner_company_name: ownerCompanyName,
                        file_owner_company_type: ownerCompanyType,
                        file_owner_company_role: ownerCompanyRole,
                        is_team_member: isNotOwnerOpen,
                        is_owner: isOwnerOpen

                    };
                }
            },

            ////////////////////////////////////
            // WorkspaceFile model validation //
            ////////////////////////////////////

            /**
             * Running all registered validations according to the order specified.
             * @returns {promise} Since this method runs asynchronously we return a promise.
             */
            validateFileModel: function validateFileModel() {
                return this.$q(function validateQueue(resolve, reject) {
                    var index = 0;
                    var keys = Object.keys(registry).sort(function keySort(a, b) {
                        var aOrder = registry[a].order;
                        var bOrder = registry[b].order;
                        if (aOrder > bOrder) {
                            return -1;
                        } else if (aOrder < bOrder) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });

                    function runSingleTest() {
                        var validator = registry[keys[index++]].validator;
                        if (angular.isFunction(validator)) {
                            validator().then(
                                function success() {
                                    if (keys.length === index) {
                                        resolve();
                                    } else {
                                        runSingleTest();
                                    }
                                },
                                function fail() {
                                    reject();
                                }
                            );
                        }
                    }

                    // start the cycle...
                    if (keys.length) {
                        runSingleTest();
                    } else {
                        resolve();
                    }
                });
            },

            /**
             * Adding a validation method to the file validation mechanism
             * @param {string} key The key to register the validation on
             * @param {function} validator Validation function that must return a promise.
             * @param {number} order Optional. The order to run the validation. The highest number will run first. Default is 0.
             */
            addFileValidation: function addFileValidation(key, validator, order) {
                registry[key] = {validator: validator, order: order || 0};
            },

            /**
             * Removes a validation from the file validation mechanism
             * @param {string} key The key of the validation to remove
             */
            removeFileValidation: function removeFileValidation(key) {
                delete registry[key];
            },

            /** SEND FILE **/
            sendFile: function sendFile(currentUser, workspace, workspaceFile, client, pvlData, hidePvl) {
                return this.$q(function _sendFile(resolve, reject) {
                    this.validateFileModel().then(function success() { // The case the file can be sent
                        if (workspaceFile.isDirectPayment()) {
                            return this.WorkspaceFilesManager.payToUser(workspaceFile, client).then(function success() {
                                this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info, 'FILE.SEND_FILE.DIRECT_PAYMENT._PAYMENT_DONE_');
                                resolve();
                            }.bind(this)).catch(function error(res) {
                                this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, res.data.error_message);
                                reject();
                            }.bind(this));
                        } else {
                            this.openEmailEditor(currentUser, workspace, workspaceFile, pvlData, hidePvl).then(function fileSent() {
                                resolve();
                                this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.send_file, {file_type: workspaceFile.file_type});
                                currentUser.setLastSentFileTime(Date.now());
                                if(workspaceFile.hasPayments()) {
                                    this.FacebookPixelTrackingService.trackCustom('PayableFileSent', {value: workspaceFile.payments_container.getTotalPaymentsAmount()});
                                }
                            }.bind(this)).catch(function fileDidNotSend() {
                                reject();
                            });
                        }
                    }.bind(this)).catch(function validationError() {
                        reject();
                    });
                }.bind(this));
            },

            sendFilePreview: function sendFilePreview(currentUser, workspace, workspaceFile) {
                return this.$q(function _sendFile(resolve, reject) {
                    this.openEmailEditor(currentUser, workspace, workspaceFile, null, null, true).then(
                        function fileSent() {
                            resolve();
                            this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.send_file, {file_type: workspaceFile.file_type});
                        }.bind(this),
                        function fileDidNotSend() {
                            reject();
                        }
                    );
                }.bind(this));
            },

            resendFile: function resendFile(currentUser, workspace, workspaceFile, client, pvlData) {
                var self = this;
                if (workspaceFile.isAllowedToReSend()) {
                    return this.$q(function _resendFile(resolve, reject) {
                        // Making sure the workspace file can be sent
                        this.validateFileModel().then(
                            function validateSuccess() {

                                // Get the email 'template'
                                var email = workspaceFile.getEmailToSend();
                                var usersListForEmail = workspace.members.filter(function (user) {
                                    return (!!user.email && !this.UsersManager.isCurrentUser(user._id) && !user.isMyTeamMember());
                                }.bind(this));

                                var options  = {
                                    users: usersListForEmail,
                                    subject: email.subject,
                                    body: email.html_body,
                                    generalFiles: email.file_attachments,
                                    imageFiles: email.image_attachments,
                                    senderFunction: this._getSendFileFunction(currentUser, workspaceFile, true),
                                    config: this._emailEditorConfig(workspaceFile, currentUser, pvlData, workspace),
                                    previewFunction: function previewSendToUser(user, subject, body, params, attachedFiles) {
                                        return this.previewSendToUser(workspaceFile, user, subject, body, params, attachedFiles);
                                    }.bind(this),
                                    showScheduleOption: true
                                };

                                this.ModalService.openEmailEditorModal(options)
                                .then(
                                    function sendSuccess(){
                                        resolve();
                                        self.AnalyticsService.trackSuccess(self, self.AnalyticsService.analytics_events.send_file, {file_type: workspaceFile.file_type});
                                    }.bind(this),
                                    function sendError() {
                                        reject();
                                    }
                                );
                            }.bind(this),
                            function validateError() {
                                reject();
                            }
                        );
                    }.bind(this));
                }
            },

            _emailEditorConfig: function _emailEditorConfig(workspaceFile, currUser, pvlData, workspace, hidePvl, sendFilePreview) {
                var self=this;
                var config = {};

                config.editorType = "send file";
		        config.sendAsync = true;

                if (workspaceFile && workspaceFile.owner._id !== currUser._id) {
                    var headerLabelText = this.$translate.instant('FILE.SEND_FILE.EMAIL_MODAL._NOT_OWNER_LABEL_', {ownerName: workspaceFile.owner.full_name, ownerEmail: workspaceFile.owner.email});
                    config.headerLabel = "<p>" + headerLabelText + "</p>";
                    config.fileOwner = workspaceFile.owner;

                    config.beforeSendCallback = function() {
                        self.analyticsArgs = {owner: workspaceFile.owner._id, team_member: currUser._id, app_path:"email_editor"};
                        self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.sending_file_on_behalf_of_owner_open_email, self.analyticsArgs);
                        var promise =  this.PopupMessageService.showConfirmPromise(this.PopupMessageService.severityTypes.info,
                            { translationId: 'FILE.SEND_FILE._SEND_ON_BEHALF_ ', interpolateParams: {ownerName: workspaceFile.owner.full_name, ownerEmail: workspaceFile.owner.email} }
                        );
                        promise.then(function(analyticsArgs) {
                            self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.sending_file_on_behalf_of_owner_confirmed, self.analyticsArgs);
                        }, function(analyticsArgs) {
                            self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.sending_file_on_behalf_of_owner_canceled, self.analyticsArgs);
                        });

                        return promise;
                    }.bind(this);

                }
                // TODO: Alon
                if (!hidePvl) {
                    this.PvlService.getPvlConfigForEmailEditor(config, workspaceFile);
                }

                // if ((workspaceFile.isProposal() || workspaceFile.isInvoice()) && !workspaceFile.isBooked() &&
                //     workspaceFile.isOwnedByCurrUser() &&
                //     (!workspaceFile.preferred_vendors_list || !workspaceFile.preferred_vendors_list.preferred_vendor_ids ||
                //         workspaceFile.preferred_vendors_list.preferred_vendor_ids.length === 0)) {
                //     config.showSharePVL = true;
                // }
                // if (pvlData && pvlData.pvList && pvlData.pvList.length > 0) {
                //     config.pvList = pvlData.pvList;
                //     config.pvlParams = pvlData.pvlParams;
                // }

                // Add the current workspace to the config so we know where to add any new participants
                if (workspace){
                    config.workspace = workspace;
                    config.showAddWsParticipantBtn = true;
                }
                config.ckeditor = {
                    includeToolbarItems: ['AddClientName', 'AddEmailSignature', 'addFileAttachment'],
                    height: "300px"
                };

                if (currUser.calendly_url) {
                    config.ckeditor.includeToolbarItems.push('addCalendlyLink');
                }

                if (sendFilePreview) {
                    config.sendAsync = false;
                    config.sendFilePreview = sendFilePreview;
                    config.sendButtonText = 'EMAIL_EDITOR._SEND_MYSELF_';
                    config.showAddWsParticipantBtn = false;
                    config.showBccMyselfCheckbox = false;
                    config.showSharePVL = false;
                    config.showPreviewBtn = false;
                    config.visualDisableInput = true;
                    config.fileType = workspaceFile.file_type;
                }

                return config;
            },

            openEmailEditor: function openEmailEditor(currentUser, workspace, workspaceFile, pvlData, hidePvl, sendFilePreview) {
                var myId = currentUser._id;
                // Get the email 'template'
                var email = workspaceFile.getEmailToSend();
                var usersListForEmail = [];
                if(sendFilePreview) {
                    usersListForEmail = [currentUser];
                } else {
                    usersListForEmail = workspace.members.filter(function (user) {
                        return (!!user.email && user._id !== myId && !user.isMyTeamMember());
                    });
                }

                var options  = {
                    users: usersListForEmail,
                    subject: email.subject,
                    body: email.html_body,
                    generalFiles: email.file_attachments,
                    imageFiles: email.image_attachments,
                    senderFunction: this._getSendFileFunction(currentUser, workspaceFile, false, sendFilePreview),
                    config: this._emailEditorConfig(workspaceFile, currentUser, pvlData, workspace, hidePvl, sendFilePreview),
                    previewFunction: function previewSendToUser(user, subject, body, params, attachedFiles) {
                        return this.previewSendToUser(workspaceFile, user, subject, body, params, attachedFiles);
                    }.bind(this),
                    showScheduleOption: true
                };

                return this.ModalService.openEmailEditorModal(options);
            },

            _getSendFileFunction: function _getSendFileFunction(currUser, workspaceFile, isResend, sendFilePreview, scheduledSendDate) {

                if (!sendFilePreview) {
                    return function asyncSenderFunction(users, subject, body, params, attachedFiles, scheduledSendDate) {
                        var data = {
                            file_id: workspaceFile._id,
                            recipients_ids: users.map(function(user) { return user._id; }),
                            email: {
                                subject: subject,
                                html_body: body,
                                email_type: 'proposal'
                            },
                            pvl_id: params['pvlId'],
                            image_attachments: attachedFiles.imageFiles,
                            file_attachments: attachedFiles.generalFiles,
                            is_resend: !!isResend,
                            scheduled_send_date: scheduledSendDate
                        };
                        return this.PendingTasksManager.createPendingTask(this.PendingTasksManager.pendingTasksTypes.sendFile, data).then(function taskCompleted(data) {
                            this.OnboardingService.setSendFileComplete(workspaceFile);
                            return data;
                        }.bind(this));
                    }.bind(this);
                }

                return function senderFunction(user, subject, body, isLast, params, attachedFiles, scheduledSendDate) {
                    params.isResend = !!isResend;
                    return this.sendToUser(workspaceFile, user, subject, body, isLast, params, attachedFiles, scheduledSendDate);
                }.bind(this);
            },

            sendToUser: function sendToUser(workspaceFile, user, subject, body, isLast, params, attachedFiles, scheduledSendDate) {
                var sendFilePreview = this.UsersManager.isCurrentUser(user._id);
                var email = workspaceFile.getEmailToSend();
                var promise;
                if(sendFilePreview) {
                    promise = this.WorkspaceFilesManager.sendFilePreview(workspaceFile, subject, body, email.email_type, attachedFiles);
                } else {
                    promise = this.WorkspaceFilesManager.sendFileToUser(workspaceFile, user, subject, body, email.email_type, isLast, params, attachedFiles, scheduledSendDate);
                }
                promise.then(function sendToUserSuccess() {
                    if (isLast && (workspaceFile.isProposal() || workspaceFile.isInvoice())) {
                        this.OnboardingService.setSendFileComplete(workspaceFile);
                    }
                }.bind(this));

                return promise;
            },

            previewSendToUser: function previewSendToUser(workspaceFile, user, subject, body, params ,attachedFiles) {
                var self = this;
                var fileOwner = workspaceFile.owner;
                var fileType = workspaceFile.file_type;
                var gaAnalyticsTrack = this.AnalyticsService;
                var email = workspaceFile.getEmailToSend();
                var promise = this.EmailPreviewManager.getWorkspaceFileEmailPreview(workspaceFile, user, subject, body, email.email_type, attachedFiles);
                promise.then(
                    function success() {
                        console.log('success');
                    },
                    function error() {
                        console.log('error');
                    }
                );

                return promise;
            },

            setCreatingFileListener: function setCreatingFileListener(callback){
                this.creatingFileListener = callback;
            } ,

            removeCreatingFileListener: function removeCreatingFileListener(callback){
                this.creatingFileListener = null;
            } ,

            setCreatingFile: function setCreatingFile(){
                if(this.creatingFileListener){
                    this.creatingFileListener.setCreatingFile();
                }
            },

            removeCreatingFile: function removeCreatingFile(){
                if(this.creatingFileListener){
                    this.creatingFileListener.removeCreatingFile();
                }
            },

            getLastEditedText: function getLastEditedText(workspaceFile, user) {
                if (workspaceFile.last_edited_by.user_id == null) {
                    return "";
                } else {
                    var date = this.moment(workspaceFile.last_edited_by.last_edited_on).format('MMM DD, h:mm a');
                    if (workspaceFile.last_edited_by.user_id !== user._id) {
                        var maxNameLength = 75;
                        if(workspaceFile.last_edited_by.user_full_name.length > maxNameLength){
                            return this.$translate.instant('FILE.HEADER._LAST_EDITED_AT_', {
                                date: date
                            });
                        } else {
                            return this.$translate.instant('FILE.HEADER._LAST_EDITED_BY_USER_', {
                                name: workspaceFile.last_edited_by.user_full_name,
                                date: date
                            });
                        }
                    } else if (user.company.doesCurrUserHaveTeamMembers()){
                        return this.$translate.instant('FILE.HEADER._LAST_EDITED_BY_YOU_', {
                            date: date
                        });
                    }
                    else{
                        return this.$translate.instant('FILE.HEADER._LAST_EDITED_AT_', {
                            date: date
                        });
                    }


                }
            },

            showPreferredVendorList: function showPreferredVendorList(workspaceFile) {
                return this.PvlService.showPreferredVendorList(workspaceFile.preferred_vendors_list._id, workspaceFile.event._id);
            },

            /** CLIENT ON-SITE **/
            bookInPerson: function bookInPerson(currentUser, workspace, workspaceFile, client, pvlData) {

                return this.$q(function _sendFile(resolve, reject) {
                    // Making sure the workspace file can be sent
                    this.validateFileModel().then(
                        function success() { // The case where the client can login

                            var usersListForEmail = workspace.members.filter(function (user) {
                                return (!!user.email && user._id !== currentUser._id && !user.isMyTeamMember());
                            });

                            if(usersListForEmail.length > 0){
                                client = usersListForEmail[0];
                            }

                            // Launch login as client modal
                            this.ModalService.openLoginAsClientModal(client, workspaceFile._id).then(
                                function success(result) {
                                    this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.login_as_client, {file_id: workspaceFile._id});
                                    // Send generic login email to client so they can access the file later on
                                    if(result === 'login'){
                                        this.sendLoginEmailToClient(client, workspaceFile);
                                    }
                                    resolve(result);
                                }.bind(this),
                                function fail() {
                                    reject();
                                }
                            );
                        }.bind(this),
                        function validationError() {
                            reject();
                        }
                    );
                }.bind(this));
            },

            sendLoginEmailToClient: function sendLoginEmailToClient(client, workspaceFile){
                var emailTemplate = workspaceFile.getEmailToSend();
                var body = '<div style="color:#8d9aa5;padding-left: 10px;padding-top: 5px;font-family: sans-serif;margin:0; line-height:17px;">' +
                        '<p style="padding-top: 5px;font-family: arial,sans-serif;font-size: 14px;margin:0;">' +
                        'This ' + emailTemplate.email_type + ' was shared with you in person.</p></div>'
                return this.sendToUser(workspaceFile, client, emailTemplate.subject, body, true, {clientLogin: true});
            },

            arePaymentsAndProposalAmountsEqual: function arePaymentsAndProposalAmountsEqual(paymentsContainer) {
                var proposalValue = paymentsContainer.getTotalProposalValue();
                var paymentsAmount = paymentsContainer.getTotalPaymentsAmount();
                if (proposalValue === undefined || paymentsAmount === undefined) {
                    return false;
                }
                return proposalValue.toFixed(2) === paymentsAmount.toFixed(2);
            },

            setShowTemplatesMenu: function setShowTemplatesMenu() {
                if (!this.DeviceService.checkIfMobileSize()) {
                    this.showTemplatesMenu = true;
                }
            },

            shouldShowTemplatesMenu: function shouldShowTemplatesMenu() {
                var oldValue = this.showTemplatesMenu;
                this.showTemplatesMenu = false;
                return oldValue;
            },

            createFileByType: function createFileByType(fileType, workspace, recentFileId, templateId) {

                var promise;

                switch (fileType){
                    case "invoice":
                        promise = this.WorkspaceFilesManager.createInvoice(workspace, recentFileId, templateId);
                        break;
                    case "proposal":
                        promise = this.WorkspaceFilesManager.createProposal(workspace, recentFileId, templateId);
                        break;
                    case "agreement":
                        promise = this.WorkspaceFilesManager.createAgreement(workspace, recentFileId, templateId);
                        break;
                    case "questionnaire":
                        promise = this.WorkspaceFilesManager.createQuestionnaire(workspace, recentFileId, templateId);
                        break;
                    case "timeline":
                        promise = this.WorkspaceFilesManager.createTimeline(workspace, recentFileId, templateId);
                        break;
                    case "brochure":
                        promise = this.WorkspaceFilesManager.createBrochure(workspace, recentFileId, templateId);
                        break;
                    case "setPaymentInvoice":
                        promise = this.WorkspaceFilesManager.createSetPaymentInvoice(workspace, recentFileId, templateId);
                        break;
                    default:
                        break;
                }

                return promise;
            },

            createFileByTypeWithProject: function createFileByType(fileType, recentFileId, templateId, projectData) {
                var promise = this.WorkspaceFilesManager.createWorkspaceFileAndProject(fileType, recentFileId, templateId, projectData);
                return promise;
            },

            _createFileSuccess: function _createFileSuccess(response, fileType, fileOriginType, workspace_file_id, isReplaceUrl) {

                // if invoice or proposal we mark it for onboarding
                if(fileType === "invoice" || fileType === "proposal") {
                    this.OnboardingService.setOnboardingWorkspaceFile(workspace_file_id);
                    this.OnboardingService.setStepComplete(this.OnboardingService.OnboardingSteps.createFile);
                }

                if(fileOriginType !== this.Enums.createFileOriginType.template) {
                    this.setShowTemplatesMenu();
                }

                this.gotoWorkspaceFileById(workspace_file_id, null, null, isReplaceUrl);
            },

            _createFileError: function _createFileError(response) {
                this.removeCreatingFile();
            },

            createFile: function createFile(fileType, workspace, recentFileId, templateId, user, isReplaceUrl) {

                // no vendors, but we have clients (for setPaymentInvoice)
                if(fileType === "setPaymentInvoice" && !workspace.shouldAllowSetPaymentInvoice(user)) {
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info,
                        'WORKSPACE.DIRECT_PAYMENT._NO_VENDOR_OR_TO_MANY_MEMBERS_');
                    return this.$q.reject();
                }

                // mark as in progress
                this.setCreatingFile();

                var fileOriginType = this.Enums.createFileOriginType.blank;
                if(recentFileId) {
                    fileOriginType = this.Enums.createFileOriginType.file;
                } else if(templateId) {
                    fileOriginType = this.Enums.createFileOriginType.template;
                }

                // call create
                var promise = this.createFileByType(fileType, workspace, recentFileId, templateId);

                promise.then(
                    function createFileSuccess(response) {
                        var workspace_file_id = response.data._id;
                        this._createFileSuccess(response, fileType, fileOriginType, workspace_file_id, isReplaceUrl);
                    }.bind(this))
                    .catch(this._createFileError.bind(this));

                return promise;
            },

            createFileWithProject: function createFileWithProject(fileType, recentFileId, templateId, projectData) {

                // mark as in progress
                this.setCreatingFile();

                var fileOriginType = this.Enums.createFileOriginType.blank;
                if(recentFileId) {
                    fileOriginType = this.Enums.createFileOriginType.file;
                } else if(templateId) {
                    fileOriginType = this.Enums.createFileOriginType.template;
                }

                // call create
                var promise = this.createFileByTypeWithProject(fileType, recentFileId, templateId, projectData);

                promise.then(
                    function createFileSuccess(response) {
                        this._createFileSuccess(response, fileType, fileOriginType, response.data.workspace_file_id);
                    }.bind(this))
                    .catch(this._createFileError.bind(this));

                return promise;
            },

            /////////////////////////////////////////////////
            // File Validations
            ////////////////////////////////////////////////
            validateFileTitle: function validateFileTitle(workspaceFile, defaultFileName) {
                return this.$q(function fileTitleValidationPromise(resolve, reject) {
                    if (!!workspaceFile.file_title && workspaceFile.file_title !== defaultFileName) {
                        resolve();
                    } else {
                        var promise = this.ModalService.openFileTitleModal(workspaceFile);
                        promise.then(
                            function success() {
                                this.WorkspaceFilesManager.saveWorkspaceFile(workspaceFile);
                                resolve();
                            }.bind(this),
                            function fail() {
                                reject();
                            }
                        );
                    }
                }.bind(this));
            },

            membersFileValidation: function membersFileValidation(workspaceFile, workspace) {
                return this.$q(function membersValidationPromise(resolve, reject) {

                    // check there is at least one user with email address in the members list
                    if (workspace.hasValidRecipient()) {
                        resolve();
                    } else {

                        // user is file owner - let them add users to workspace
                        if (workspaceFile.isOwnerMode()) {

                            this.ModalService.openAddWorkspaceParticipantModal(workspace).then(
                                function usersAdded(resp) {
                                    if (resp.user) {
                                        workspace.members.add(resp.user);
                                    }

                                    if (workspace.members.length > 1) {

                                        resolve();

                                    } else {
                                        reject();
                                    }
                                }.bind(this),
                                function noNewUsers() {
                                    reject();
                                }
                            );
                        } else {
                            this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info, {
                                translationId: 'FILE.SEND_FILE._NO_MEMBERS_ON_BEHALF_ ',
                                interpolateParams: {ownerName: workspaceFile.owner.full_name}
                            });
                            reject();
                        }

                    }
                }.bind(this));
            },

            questionsFileValidation: function questionsFileValidation(workspaceFile) {
                return this.$q(function questionsFileValidationPromise(resolve, reject) {

                    // check questions validation
                    var isValid = workspaceFile.file_dynamic_content.isQuestionsValid();

                    // pass validation if valid
                    if (isValid) {
                        resolve();
                    } else {

                        // trigger error check to diaply in the UI
                        this.QuestionsStateService.triggerErrorCheck();

                        // show error message
                        var errorMessage = 'Just a sec, some of the fields are still empty. press Confirm and look for the red fields.';
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, errorMessage);

                        // reject the validation
                        reject();
                    }
                }.bind(this));
            },

            /**
             * Returns a list of filmstrip links given a workspace file.
             *
             * @param {Object} workspaceFile - Workspace model object
             * @param {Boolean} isExampleProposal - Used to determine if the
             *        links should be configured for the example proposal flow.
             * @param {String} activeId - The active filmstrip item ('proposal', 'agreement', 'pay')
             * @return {Array} links - A list of filmstrip items
             *
             * TODO: Currently this only supports the filmstrip items in the stepped workspace flow.
             * Continue to refactor all filmstrip item generation logic here.
             */
            getFilmstripLinksForWorkspace: function(workspaceFile, isExampleProposal, activeId, stateParams) {
                var _isProposal = workspaceFile.isProposal();
                var _isInvoice = workspaceFile.isInvoice();

                var links = [];

                // If this is not an example proposal, we want the user force the
                // client through each step of the workspace so the do not miss
                // anything.
                var enableAgreement = workspaceFile.isAgreementSeen();
                var enablePayments = workspaceFile.isPaymentsSeen();
                var isPreviewMode = this.PreviewModeService.isInPreviewMode();
                if (isExampleProposal) {
                    enableAgreement = true;
                    enablePayments = true;
                }

                var linkToProposal = {};
                angular.extend(linkToProposal, { workspace_file_id: workspaceFile._id, preventStateChangeModals: isPreviewMode }, stateParams);
                linkToProposal = "(" + JSON.stringify(linkToProposal) + ")";

                links.push({
                    enabled: true,
                    isActive: activeId === 'proposal',
                    label: this.getProposalLabel(workspaceFile),
                    sparam: linkToProposal,
                    sref: (_isInvoice || _isProposal) ? this.AppStates.root_core_workspaceFile_stepProposal : this.AppStates.root_core_workspaceFile_stepAgreement,
                });

                if (_isProposal) {
                    links.push({
                        enabled: enableAgreement || isPreviewMode,
                        isActive: activeId === 'agreement',
                        label: 'FILE.FILMSTRIP._AGREEMENT_',
                        sparam: linkToProposal,
                        sref: this.AppStates.root_core_workspaceFile_stepAgreement,
                    });
                }

                if (_isInvoice || _isProposal) {
                    links.push({
                        enabled: enablePayments || isPreviewMode,
                        isActive: activeId === 'pay',
                        label: 'FILE.FILMSTRIP._PAY_',
                        sparam: linkToProposal,
                        sref: this.AppStates.root_core_workspaceFile_stepPayment,
                    });
                }



                return links;
            },

            getPriceRecommendationText: function getPriceRecommendationText(recommendationRespFromServer, currPrice) {
                var resultData = recommendationRespFromServer && recommendationRespFromServer.data && recommendationRespFromServer.data.result;
                if (!resultData) {
                    return;
                }
                currPrice = currPrice || resultData.total_price; // fallback

                var currPercentilePrice = Math.round(resultData.percentiles_rank);
                if (currPercentilePrice < 10 || currPercentilePrice > 95) {
                    return; // playing it safe-ish, out of these we probably don't have a good answer
                }
                var extractPctPrice = function (pct) {
                    return Math.round(resultData.percentiles[pct + '.0']);
                };

                var nextRankPrice = null;
                var startsAtOrIs = null;
                var nextRankPriceDesc = currPercentilePrice;
                if (currPercentilePrice < 50) {
                    nextRankPrice = extractPctPrice(50);
                    nextRankPriceDesc = 'average';
                    startsAtOrIs = 'is';
                } else if (currPercentilePrice < 75) {
                    nextRankPrice = extractPctPrice(75);
                    nextRankPriceDesc = 'top 25%';
                    startsAtOrIs = 'starts at';
                } else if (currPercentilePrice < 95) {
                    nextRankPrice = extractPctPrice(95);
                    nextRankPriceDesc = 'top 5%';
                    startsAtOrIs = 'starts at';
                }
                var priceDiff = Math.round(nextRankPrice - currPrice);
                if (priceDiff < 0 || (priceDiff / (currPrice * 1.0) > 1.5)) {
                    return; // not good, signals a possible wrong service detection
                }
                var areaDesc = 'area';
                if (resultData.winning_plan.geo_desc === 'city' || resultData.winning_plan.geo_desc === 'state') {
                    areaDesc = resultData.winning_plan.geo_desc;
                }
                var currPercentilePriceDesc;
                if (currPercentilePrice === 50) {
                    currPercentilePriceDesc = 'average';
                } else if (currPercentilePrice > 50) {
                    currPercentilePriceDesc = 'top ' + (100 - currPercentilePrice) + '%';
                } else if (currPercentilePrice < 50) {
                    currPercentilePriceDesc = 'bottom ' + currPercentilePrice + '%';
                }

                //  Your current price is at the top x% for similar offerings in your industry and area, adjusted seasonally.
                //  If you bump up your price by $x, you’ll be within the top 25%, which starts at $x.

                // note: <S is hacky <Strong> replace so it wont interfere with the formatTextEvenly below
                var resText1 = [
                    'Your current price is at the <S',
                    currPercentilePriceDesc,

                    'S> for similar offerings in your industry and your ',
                    // 'S> for items of type "',
                    // resultData.category,
                    // '" (or similar) in your ',

                    areaDesc,
                    ', adjusted seasonally.',
                ].join('');

                var resText2 = [
                    'If you bump up your ',
                    (resultData.discount ? '<SoriginalS> ' : ''),
                    'price by <S$',
                    priceDiff,
                    'S> you’ll be within the ',
                    nextRankPriceDesc,
                    ' which ',
                    startsAtOrIs,
                    ' $',
                    nextRankPrice,
                    '.'
                ].join('');
                var resText = (
                    this.UIUtils.formatTextEvenly(resText1, 40, '<br/>') +
                    '<br/><br/>' +
                    this.UIUtils.formatTextEvenly(resText2, 40, '<br/>')
                ).replace(/<S/g, '<strong>').replace(/S>/g, '</strong>');

                return resText;
            },

        formatFileTypeToDisplayName: function formatFileTypeToDisplayName(fileType, capitalize) {
                var fileTypeName = fileType === 'agreement' ? 'contract' : fileType;
                return capitalize ? this.UIUtils.capitalize(fileTypeName) : fileTypeName;
            },

            isNewBrochure: function isNewBrochure(currFile) {
                return currFile.is_new_brochure;
            },

            validateBrochureSelection: function validateBrochureSelection(workspaceFile) {
                var fileContent = workspaceFile.file_dynamic_content;
                var sections = fileContent.file_sections;
                var allSectionsValid = sections.every(function(section) {
                    return section.isSelectionValid();
                });
                return allSectionsValid;
            },

            shouldShowClientPreviewModal: function shouldShowClientPreviewModal() {
                var clientFlowHash = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.clientFlowModal) || {};
                return !clientFlowHash.seen;
            },

            clientPreviewModalIfNeeded: function clientPreviewModalIfNeeded(fileType) {
               if (!this.shouldShowClientPreviewModal()) {
                   var deferred = this.$q.defer();
                   deferred.resolve();
                   return deferred.promise;
               }

                return this.ModalService.openClientFlowModal({fileType: fileType})
                    .finally(function () {
                        this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.clientFlowModal, {seen: true});
                    }.bind(this));
            },

            shouldShowSendFilePreview: function shouldShowSendFilePreview(workspaceFile) {
                if (
                    workspaceFile
                    && workspaceFile.isBookable()
                    && !this.DeviceService.checkIfMobileSize()
                ) {
                    var currUser = this.UsersManager.getCurrUser();
                    return !currUser.isActivated();
                }
            }

        };
    });
}());
